import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqItems } from "../data/faq";
const ease = [0.23, 1, 0.32, 1] as const;
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="bg-sand py-20 md:py-28" data-id="element-57" data-mp="1ge0kd14j9kjx">
      <div className="mx-auto grid max-w-site gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-58" data-mp="2e0prfpe3encn">
        <div className="lg:col-span-4" data-id="element-59" data-mp="2913bv9askv0o">
          <div className="lg:sticky lg:top-28" data-id="element-60" data-mp="2924mxdrt5hie">
            <h2 id="faq-title" className="font-display text-4xl font-medium tracking-tight text-ink md:text-5xl" data-id="element-61" data-mp="241qpepnu1pym">
              Questions fréquentes
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-62" data-mp="1z5jiatjpa8f3">
              Recherche du véhicule, aménagement, homologation : on vous répond.
            </p>
            <Link to="/contact" className="mt-8 inline-flex items-center rounded-full bg-ink px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-forest" data-id="element-63" data-mp="nn8ltwzzwjtf">
              Poser une autre question
            </Link>
          </div>
        </div>

        <ul className="border-t border-ink/15 lg:col-span-8" data-id="element-64" data-mp="fjibdkddsylz">
          {faqItems.map((item, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={item.question} className="border-b border-ink/15" data-id="element-65" data-mp="6pdd4fvx4kwf" data-mpi={i}>
                <h3 data-id="element-66" data-mp="bjpy4ud1m4aa">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-67" data-mp="bk9hmficd0qf">
                    <span className="text-lg font-medium text-ink md:text-xl" data-id="element-68" data-mp="3nzbr3wzw261z">{item.question}</span>
                    <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color,color] duration-200 ${isOpen ? "rotate-45 bg-clay text-white" : "bg-paper text-ink"}`} data-id="element-69" data-mp="1ugkvi5fo9yja">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="1fszsscmpm1bw" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="2ddmbsmeofl2j">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease
              }} className="overflow-hidden" data-id="element-72" data-mp="28hf5gsidc7k2">
                      <div className="max-w-2xl pb-7 text-base leading-relaxed text-muted" data-id="element-73" data-mp="nzppjggwz8ne">
                        {item.answer && <p data-id="element-74" data-mp="2zpfeypog0ewd">{item.answer}</p>}
                        {item.items && <ul className="mt-3 space-y-1.5" data-id="element-75" data-mp="33qr3sszhsw3i">
                            {item.items.map(li => <li key={li} className="flex gap-3" data-id="element-76" data-mp="38n985rqwusfb">
                                <span className="mt-[0.6rem] h-1.5 w-1.5 shrink-0 rounded-full bg-clay" aria-hidden="true" data-id="element-77" data-mp="3dfshudmh93eu" />
                                {li}
                              </li>)}
                          </ul>}
                        {item.outro && <p className="mt-3" data-id="element-78" data-mp="3rf1z7gmf63ke">{item.outro}</p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}